import { axiosInstance } from "@hopper-b2b/api";
import type { NubankUserInfo } from "./userInfo";

export const apiVersionPrefix = "/api/v0";
export const authPrefix = `${apiVersionPrefix}/auth`;
export const impersonateUserPath = `${authPrefix}/impersonate`;

export interface NubankSessionInfo {
  hopperSessionToken: string;
  hopperUserIdToken: string;
  nubankAccessToken: string;
  hopperUserId: string;
  userInfoResponse: NubankUserInfo;
  kustomerAccessToken?: string;
  isImpersonation: boolean;
}

export interface StartSessionRequest {
  code: string;
  initiator?: string;
}

export const impersonateUserSession = (
  userId: string
): Promise<NubankSessionInfo> =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async (resolve, reject) => {
    const reqBody = {
      hopperUserId: userId,
    };
    try {
      const res = await axiosInstance.post(impersonateUserPath, reqBody);
      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });

export default impersonateUserSession;
